<template>
  <div
    v-if="
      (neopassDatas.sectors &&
        Object.values(neopassDatas.sectors).length > 0) ||
      (neopassDatas.families && Object.values(neopassDatas.families).length > 0)
    "
  >
    <div class="flex flex-col space-y-10">
      <div
        v-if="
          neopassDatas.sectors && Object.values(neopassDatas.sectors).length > 0
        "
        class="w-full"
      >
        <bar
          id-chart="sector"
          title="Secteur d'activité"
          orientation="vertical"
          :labels="sectors.labels"
          :values="sectors.datas"
          height="400"
          :stacked="false"
          :display-legend="false"
        />
      </div>
      <div>
        <p
          class="text-2sm text-gray-600"
          v-for="(lib, n) in Object.keys(neopassDatas.sectors)"
          :key="n"
        >
          {{ lib }}
        </p>
      </div>
      <div
        v-if="
          neopassDatas.families &&
          Object.values(neopassDatas.families).length > 0
        "
        class="w-full"
      >
        <bar
          id-chart="families"
          title="Famille professionnelle"
          orientation="vertical"
          :labels="families.labels"
          :values="families.datas"
          height="400"
          :stacked="false"
          :display-legend="false"
        />
      </div>
      <div>
        <p
          class="text-2sm text-gray-600"
          v-for="(lib, n) in Object.keys(neopassDatas.families)"
          :key="n"
        >
          {{ lib }}
        </p>
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-1/10 text-gray-600">
    Aucune donnée à afficher.
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Bar from '../../../components/Charts/Bar';

import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Bar,
  },

  name: 'CartoColCompetencesCles',

  data() {
    return {
      constants: Constants,
    };
  },
  mounted() {
    //
  },
  methods: {
    ...mapMutations({
      //
    }),
    color(c) {
      if (c == 'indigo') {
        return '#3A18D1';
      } else if (c == 'pink') {
        return '#FF1C80';
      } else if (c == 'twelveColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
          '#F9A1D4',
        ];
      } else if (c == 'elevenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
        ];
      } else if (c == 'tenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
        ];
      } else if (c == 'nineColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
        ];
      } else if (c == 'eightColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
        ];
      } else if (c == 'evaluation') {
        return [
          '#FBE6F0',
          '#FEF3F8',
          '#FFEDE3',
          '#FFF6F1',
          '#DFE0F2',
          '#FAF7FC',
          '#EAF5F6',
          '#D3F1F5',
        ];
      }
    },
  },
  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesCollectives/neopassDatas',
    }),

    sectors() {
      let infos = this.neopassDatas.sectors;

      let labels = Object.keys(infos).map((l) => l.substring(0, 1));
      let datas = Object.values(infos);

      return {
        labels: labels,
        datas: [
          {
            label: 'En poste',
            data: datas,
            backgroundColor: this.color('twelveColors'),
          },
        ],
      };
    },

    families() {
      let infos = this.neopassDatas.families;

      let labels = Object.keys(infos).map((l) => l.substring(0, 3));
      let datas = Object.values(infos);

      return {
        labels: labels,
        datas: [
          {
            label: 'En poste',
            data: datas,
            backgroundColor: this.color('twelveColors'),
          },
        ],
      };
    },
  },
};
</script>
